import { message } from 'antd';
import { AxiosError } from 'axios';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@/services/api';
import { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';
import type { RosaReportImage } from '@/types/entities/Rosa';

type UpdateImageRequest = BaseContext & {
	image_id: string;
	report_id: string;
	description: string;
};

type UpdateImageResponse = RosaReportImage;

type UpdateImageError = AxiosError<any>;

async function updateImageDescription(parameters: UpdateImageRequest): Promise<UpdateImageResponse> {
	const url = `/ergonomic-tool/rosa/images/${parameters.image_id}`;
	const { data } = await Api.put<UpdateImageResponse>(url, parameters);
	return data;
}

export const useUpdateImage = () => {
	const queryClient = useQueryClient();
	return useMutation<UpdateImageResponse, UpdateImageError, UpdateImageRequest>(
		(payload) => updateImageDescription(payload),
		{
			onSuccess: () => {
				message.success(I18n.get('Image updated successfully'));
				queryClient.invalidateQueries([ROSA_QUERY_KEYS.GET_ROSA_IMAGES]);
			}
		}
	);
};
